<template>
  <div class="contact-container">
    <div style="color: #f8f9fa; font-size: 1px;">1</div>
    <!-- 聯繫方式區塊 -->
    <div class="contact-info-section">
      <div class="content-wrapper">
        <SimpleHeader title="聯繫我們" subtitle="多種渠道隨時為您服務" />

        <div class="info-cards">
          <div class="info-card" v-for="(item, index) in contactMethods" :key="index" data-aos="fade-up"
            :data-aos-delay="index * 100">
            <div class="card-icon">
              <img :src="item.icon" :alt="item.title">
            </div>
            <div class="card-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.content }}</p>
              <div class="supplement" v-if="item.supplement">{{ item.supplement }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 反饋表單區塊 -->
    <div class="feedback-section">
      <div class="content-wrapper">
        <div class="feedback-wrapper">
          <div class="illustration" data-aos="fade-right">
            <img src="@/assets/Mobile-rafiki.png" alt="聯繫我們" loading="lazy">
          </div>

          <div class="feedback-form" data-aos="fade-left">
            <div class="form-header">
              <div class="subtitle">意見反饋</div>
              <h2>隨時聆聽您的聲音</h2>
            </div>

            <div class="form-body">
              <div class="input-group dual">
                <div class="input-item">
                  <label>名字</label>
                  <input type="text" placeholder="請輸入名字" v-model="form.firstName">
                </div>
                <div class="input-item">
                  <label>姓氏</label>
                  <input type="text" placeholder="請輸入姓氏" v-model="form.lastName">
                </div>
              </div>

              <div class="input-item" style="width: 100%;margin-bottom: 20px;">
                <label>電子郵箱</label>
                <input type="email" placeholder="example@domain.com" v-model="form.email" style="width: 100%;">
                <p v-if="isValid === false" style="color: red;">* 邮箱格式不正确</p>
              </div>

              <div class="input-group">
                <label>反饋內容</label>
                <textarea placeholder="請詳細描述您的需求或建議" v-model="form.content"></textarea>
              </div>
              <button class="submit-btn" @click="submitForm">
                <span>提交信息</span>
                <i class="bi bi-send-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isValid: null,
      contactMethods: [
        {
          icon: require('@/assets/email.png'),
          title: '電子郵件',
          content: 'support@techinnovate.com',
          supplement: '24小時內回復'
        },
        {
          icon: require('@/assets/phone.png'),
          title: '客戶服務',
          content: '+852 6688 9966',
          supplement: '周一至周六 8:00-18:00'
        },
        {
          icon: require('@/assets/time.png'),
          title: '線下訪問',
          content: '香港科技園5號樓12層',
          supplement: '需提前預約'
        }
      ],
      form: {
        firstName: '',
        lastName: '',
        email: '',
        content: ''
      }
    }
  },
  mounted() {
    this.GetPersonalInformationList()
  },

  methods: {
    //获取产品案例的列表
    GetPersonalInformationList() {
      this.$axios.get(`/personalInformation/list?page=1&perPage=100000`)
        .then(res => {
          this.contactMethods[0].content = res.data.data.items[0].email
          this.contactMethods[1].content = res.data.data.items[0].phone
          this.contactMethods[1].supplement = res.data.data.items[0].business_at
          this.contactMethods[2].content = res.data.data.items[0].address

        })
        .catch(e => {
          console.log(e)
        })
    },
    submitForm() {
      if (this.form.firstName != '' && this.form.lastName != '' && this.form.email != '' && this.form.content != '') {
        this.validateEmail()
        if (this.isValid) {
          this.$axios.post("/message/add", this.form)
            .then(res => {
              console.log(res)
              this.form.firstName = ""
              this.form.lastName = ""
              this.form.email = ""
              this.form.content = ""
              this.open2()
            })
            .catch(e => {
              console.log(e)
            })
        }
      } else {
        this.open1()
      }
    },
    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      this.isValid = emailRegex.test(this.form.email);
    },
    open1() {
      this.$notify({
        title: '警告',
        message: '请将信息填写完整，再提交信息',
        type: 'warning'
      });
    },
    open2() {
      this.$notify({
        title: '成功',
        message: '信息提交成功，我们会尽快处理问题，感谢您对我们的建议。',
        type: 'success'
      });
    },
  }
}
</script>

<style scoped>
.contact-container {
  background: linear-gradient(135deg, #f9fbfd 0%, #f2f6fa 100%);
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 聯繫方式區塊樣式 */
.contact-info-section {
  padding: 0 0 4rem;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 4rem;
}

.info-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 8px 32px rgba(5, 42, 92, 0.06);
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.card-icon {
  width: 80px;
  height: 80px;
  background: #f4f7ff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
}

.card-icon img {
  width: 40px;
  height: 40px;
}

.card-content h3 {
  font-size: 1.5rem;
  color: #1a2943;
  margin-bottom: 0.5rem;
}

.card-content p {
  font-size: 1.2rem;
  color: #4d5a6d;
  font-weight: 500;
}

.supplement {
  margin-top: 0.8rem;
  font-size: 0.95rem;
  color: #8c9aaf;
  padding: 6px 12px;
  background: #f8faff;
  border-radius: 8px;
  display: inline-block;
}

/* 反饋表單區塊樣式 */
.feedback-section {
  padding: 4rem 0 8rem;
}

.feedback-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  background: #ffffff;
  border-radius: 32px;
  padding: 4rem;
  box-shadow: 0 12px 48px rgba(5, 42, 92, 0.08);
}

.illustration img {
  width: 100%;
  height: auto;
  border-radius: 24px;
}

.form-header {
  margin-bottom: 3rem;
}

.form-header .subtitle {
  font-size: 1.2rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.form-header h2 {
  font-size: 2.4rem;
  color: #1a2943;
  line-height: 1.3;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-group label {
  display: block;
  font-size: 1rem;
  color: #4d5a6d;
  margin-bottom: 0.8rem;
  font-weight: 500;
}

.input-group.dual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

input,
textarea {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e3e8f2;
  border-radius: 12px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

input:focus,
textarea:focus {
  border-color: #4d8eff;
  outline: none;
}

textarea {
  height: 120px;
  resize: vertical;
}

.submit-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #1a2943;
  color: white;
  padding: 16px 40px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  margin-top: 2rem;
}

.submit-btn i {
  font-size: 1.2rem;
}

@media (max-width: 1200px) {
  .info-cards {
    grid-template-columns: 1fr;
  }

  .feedback-wrapper {
    grid-template-columns: 1fr;
    padding: 2rem;
  }

  .illustration {
    max-width: 500px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 0 1.5rem;
  }

  .info-card {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }

  .card-icon {
    margin: 0 0 1.5rem 0;
  }

  .input-group.dual {
    grid-template-columns: 1fr;
  }

  .submit-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>